import type { IHttpClient } from "@/core/interfaces";
import { Registry } from "@/shared/infra/dependency-injection/registry";

/**
 * Recursos da Carga de Trabalho cujo PDF é a impressão do navegador. Os valores são os mesmos
 * `recurso` que o core grava na auditoria das exportações em Excel/CSV.
 */
export type PdfExportAuditResource =
  | "alocacoes/profissionais"
  | "alocacoes/obras/profissionais"
  | "alocacoes/locais"
  | "alocacoes/obras/locais"
  | "alocacoes/fornecedores"
  | "alocacoes/obras/fornecedores";

export interface PdfExportAuditParams {
  recurso: PdfExportAuditResource;
  /** Quantidade de linhas na tela impressa. */
  quantidade: number;
  dataInicio?: string;
  dataFim?: string;
  busca?: string;
}

/** Contrato do hub-bff (privilégio `hub.equipe:visualizar`, verificado pelo core). */
export const PDF_EXPORT_AUDIT_PATH = "/api/recursos/alocacoes/exportacao/auditoria";

/**
 * Registra a auditoria (RN007) do PDF. O PDF não passa pelo servidor (é a impressão do
 * navegador), então a tela avisa o servidor para que a ação fique registrada como as de
 * Excel/CSV. Falha aqui nunca impede a impressão: devolve `false` em vez de lançar.
 */
export async function recordPdfExportAudit({
  recurso,
  quantidade,
  dataInicio,
  dataFim,
  busca,
}: PdfExportAuditParams): Promise<boolean> {
  const body: Record<string, unknown> = { recurso, formato: "pdf", quantidade };
  if (dataInicio) body.dataInicio = dataInicio;
  if (dataFim) body.dataFim = dataFim;
  const term = busca?.trim();
  if (term) body.busca = term;

  try {
    await Registry.getInstance()
      .inject<IHttpClient>("HttpClient")
      .post(PDF_EXPORT_AUDIT_PATH, body);
    return true;
  } catch {
    return false;
  }
}
